import { FilterTimeFrameValue } from "server/config-api/index.js";
import { Granularity } from "server/dwhApi/common.js";

export const GRANULARITY_OPTIONS = [
  {
    key: Granularity.WEEK,
    label: "homePage:weekGranularity",
  },
  {
    key: Granularity.MONTH,
    label: "homePage:monthGranularity",
  },
];

export const PERIOD_OPTIONS = [
  {
    key: FilterTimeFrameValue.Last12Months,
    label: "datePicker:presetLabelLast12Months",
  },
  {
    key: FilterTimeFrameValue.SinceBeginning,
    label: "datePicker:presetLabelAllTime",
  },
];
